// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `app-menu-modal {
  height: 100vh;
  position: relative;
  text-transform: capitalize;
}

.header-btn {
  margin-top: 0;
  background: #990636;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  height: 64px;
  margin: -20px;
}
.header-btn ion-icon {
  width: 25px;
  height: 14px;
}

.wrapper {
  color: var(--menu-modal-text-color);
  width: 100%;
  height: 100%;
  padding: 20px;
}

a {
  color: var(--menu-modal-text-color);
}

.separator {
  margin: 5px 0;
  width: 100%;
  min-width: 70px;
  height: 5px;
  background: url('separator_menu_modal.svg') no-repeat center center/cover;
}

ion-icon {
  width: 32px;
  margin-right: 3px;
  padding: 4px;
  border-radius: 0;
}

.version {
  opacity: 0.3;
  font-size: x-small;
}

ion-row {
  align-items: center;
  padding: 2px;
  cursor: pointer;
}

.name {
  margin: 0px;
  margin-top: 35px;
  color: #FFF;
  font-family: Tusker;
  font-size: 26px;
  letter-spacing: 0.52px;
  text-transform: capitalize;
  margin-bottom: 10px;
}

.email {
  color: #fff;
  margin: 0px;
  font-size: 14px;
  margin-top: 2px;
  font-family: AppFont, sans-serif;
}

a {
  text-decoration: none;
}

ion-button {
  color: white;
  --background: rgba(255, 255, 255, 0.3);
  -webkit-backdrop-filter: blur(4px);
          backdrop-filter: blur(4px);
}

.lang-row {
  font-size: 20px;
  font-family: AppFont, sans-serif;
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
}

ion-col {
  color: #FFF;
  font-family: AppFontBlack;
  font-size: 18px;
}

.selected {
  opacity: 1 !important;
}

.lang-title {
  max-width: 90%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin: 0px;
}

ion-icon {
  zoom: 1.2;
  color: #fff;
}

.logout {
  margin: 20px 0px 0px 10px;
}
.logout ion-button {
  padding: 10px 0px;
  font-family: AppFont, sans-serif;
  text-transform: uppercase;
  --background: url('background-button.png') no-repeat center center/ 100% 100%;
  color: #fff;
  font-weight: 700;
}
.logout ion-button ion-icon {
  height: 14px;
  width: 19px;
  padding: 6px 4px;
  margin-right: 10px;
}

ion-row {
  margin-top: 6px;
}

.header-wrap {
  margin: 10px;
  width: -moz-fit-content;
  width: fit-content;
}

.selected {
  opacity: 1 !important;
}

.version {
  position: absolute;
  bottom: 3px;
  right: 10px;
}

.lang-block {
  position: absolute;
  bottom: 30px;
  left: 10px;
  padding: 0px 20px;
}
.lang-block ion-img {
  height: 35px;
  width: 35px;
}

.footer-lang {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}
.footer-lang div:first-child {
  margin-left: 20px;
}
.footer-lang div {
  margin: 0px 5px;
  text-align: center;
  padding: 8px 25px;
  --border-color: var(--ion-color-primary);
  border: 2px solid var(--ion-color-primary);
  background: #fff;
  border-radius: 50px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
}
.footer-lang div span {
  color: var(--ion-color-primary);
  text-align: center;
  font-family: AppFont600;
  font-size: 12px;
  text-transform: uppercase;
}
.footer-lang div.selected {
  background: var(--ion-color-tertiary);
  border: none;
}
.footer-lang div.selected span {
  color: white;
}

.flag-item-block {
  width: 35px;
  position: absolute;
  bottom: 20px;
  left: 35px;
}
@media (min-width: 991px) {
  .flag-item-block {
    right: 35px;
    left: unset;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/menu-modal/menu-modal.component.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAEA;EACE,aAAA;EACA,kBAAA;EACA,0BAAA;AADF;;AAGA;EACE,aAAA;EACA,mBAAA;EACA,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,YAAA;EACA,aAAA;AAAF;AAEE;EACE,WAAA;EACA,YAAA;AAAJ;;AAGA;EACE,mCAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;AAAF;;AAEA;EACI,mCAAA;AACJ;;AACA;EACE,aAAA;EACA,WAAA;EACA,eAAA;EACA,WAAA;EACA,yEAAA;AAEF;;AACA;EACE,WAAA;EACA,iBAAA;EACA,YAAA;EACA,gBAAA;AAEF;;AACA;EACE,YAAA;EACA,kBAAA;AAEF;;AACA;EACE,mBAAA;EACA,YAAA;EACA,eAAA;AAEF;;AACA;EACE,WAAA;EACA,gBAAA;EACA,WAAA;EAEA,mBAAA;EACA,eAAA;EACA,sBAAA;EACA,0BAAA;EACA,mBAAA;AACF;;AACA;EACE,WAAA;EACA,WAAA;EACA,eAAA;EACA,eAAA;EACA,gCAAA;AAEF;;AACA;EACE,qBAAA;AAEF;;AAGA;EACE,YAAA;EACA,sCAAA;EACA,kCAAA;UAAA,0BAAA;AAAF;;AAEA;EACE,eAAA;EACA,gCAAA;EACA,aAAA;EACA,mBAAA;EACA,iBAAA;AACF;;AACA;EACE,WAAA;EAEA,yBAAA;EACA,eAAA;AACF;;AAEA;EACE,qBAAA;AACF;;AACA;EACE,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,WAAA;AAEF;;AAAA;EACE,SAAA;EACA,WAAA;AAGF;;AADA;EACE,yBAAA;AAIF;AAHE;EACE,iBAAA;EACA,gCAAA;EACA,yBAAA;EACA,6EAAA;EACA,WAAA;EACA,gBAAA;AAKJ;AAJI;EACE,YAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;AAMN;;AADA;EACE,eAAA;AAIF;;AAFA;EACE,YAAA;EACA,uBAAA;EAAA,kBAAA;AAKF;;AADA;EACE,qBAAA;AAIF;;AADA;EACE,kBAAA;EACA,WAAA;EACA,WAAA;AAIF;;AAFA;EACE,kBAAA;EACA,YAAA;EACA,UAAA;EACA,iBAAA;AAKF;AAHE;EACE,YAAA;EACA,WAAA;AAKJ;;AAFA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,WAAA;AAKF;AAJE;EACE,iBAAA;AAMJ;AAJE;EACE,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,wCAAA;EACA,0CAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;AAMJ;AALM;EACE,+BAAA;EACA,kBAAA;EACA,uBAAA;EACA,eAAA;EACA,yBAAA;AAOR;AAHM;EAIE,qCAAA;EACA,YAAA;AAER;AANQ;EACE,YAAA;AAQV;;AADA;EACE,WAAA;EACA,kBAAA;EACA,YAAA;EACA,UAAA;AAIF;AC/ME;EDuMF;IAMI,WAAA;IACA,WAAA;EAMF;AACF","sourcesContent":["@import \"../../../theme/mixins\";\n\napp-menu-modal {\n  height: 100vh;\n  position: relative;\n  text-transform: capitalize;\n}\n.header-btn {\n  margin-top: 0;\n  background: #990636;\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  height: 64px;\n  margin: -20px;\n\n  ion-icon {\n    width: 25px;\n    height: 14px;\n  }\n}\n.wrapper {\n  color: var(--menu-modal-text-color);\n  width: 100%;\n  height: 100%;\n  padding: 20px;\n}\na {\n    color: var(--menu-modal-text-color);\n}\n.separator {\n  margin: 5px 0;\n  width: 100%;\n  min-width: 70px;\n  height: 5px;\n  background: url(../../../assets/tabilo/separator_menu_modal.svg) no-repeat center center/ cover;\n}\n\nion-icon {\n  width: 32px;\n  margin-right: 3px;\n  padding: 4px;\n  border-radius: 0;\n}\n\n.version {\n  opacity: 0.3;\n  font-size: x-small;\n}\n\nion-row {\n  align-items: center;\n  padding: 2px;\n  cursor: pointer;\n}\n\n.name {\n  margin: 0px;\n  margin-top: 35px;\n  color: #FFF;\n\n  font-family: Tusker;\n  font-size: 26px;\n  letter-spacing: 0.52px;\n  text-transform: capitalize;\n  margin-bottom: 10px;\n}\n.email{\n  color: #fff;\n  margin: 0px;\n  font-size: 14px;\n  margin-top: 2px;\n  font-family: AppFont, sans-serif;\n}\n\na {\n  text-decoration: none;\n  // color: white;\n}\n\n\nion-button {\n  color: white;\n  --background: rgba(255, 255, 255, 0.3);\n  backdrop-filter: blur(4px);;\n}\n.lang-row{\n  font-size: 20px;\n  font-family: AppFont, sans-serif;\n  display: flex;\n  align-items: center;\n  flex-wrap: nowrap;\n}\nion-col {\n  color: #FFF;\n\n  font-family: AppFontBlack;\n  font-size: 18px;\n}\n\n.selected{\n  opacity: 1 !important;\n}\n.lang-title{\n  max-width: 90%;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  margin: 0px;\n}\nion-icon {\n  zoom: 1.2;\n  color: #fff;\n}\n.logout{\n  margin: 20px 0px 0px 10px;\n  ion-button {\n    padding: 10px 0px;\n    font-family: AppFont, sans-serif;\n    text-transform: uppercase;\n    --background: url(../../../assets/tabilo/background-button.png) no-repeat center center/ 100% 100%;\n    color: #fff;\n    font-weight: 700;\n    ion-icon {\n      height: 14px;\n      width: 19px;\n      padding: 6px 4px;\n      margin-right: 10px;    \n    }\n  }\n}\n\nion-row{\n  margin-top: 6px;\n}\n.header-wrap{\n  margin: 10px;\n  width: fit-content;\n}\n\n\n.selected{\n  opacity: 1 !important;\n}\n\n.version {\n  position: absolute;\n  bottom: 3px;\n  right: 10px;\n}\n.lang-block{\n  position: absolute;\n  bottom: 30px;\n  left: 10px;\n  padding: 0px 20px;\n\n  ion-img {\n    height: 35px;\n    width: 35px;\n  }\n}\n.footer-lang{\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  div:first-child {\n    margin-left: 20px;\n  }\n  div {\n    margin: 0px 5px;\n    text-align: center;\n    padding: 8px 25px;\n    --border-color: var(--ion-color-primary);\n    border: 2px solid  var(--ion-color-primary);\n    background: #fff;\n    border-radius: 50px;\n    overflow: hidden;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-weight: bold;\n      span {\n        color: var(--ion-color-primary);\n        text-align: center;\n        font-family: AppFont600;\n        font-size: 12px;\n        text-transform: uppercase;\n      }\n    }\n    div {\n      &.selected {\n        span {\n          color: white;\n        }\n        background:  var(--ion-color-tertiary);\n        border: none;\n      }\n    }\n}\n.flag-item-block {\n  width: 35px;\n  position: absolute;\n  bottom: 20px;\n  left: 35px;\n  @include desktop {\n    right: 35px;\n    left: unset;\n  }\n\n}","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
